import groupService from '../../services/groupService'

const state = {
  groups: [],
}

const getters = {
  getGroups(state) {
    return state.groups
  },
}

const mutations = {
  setGroups(state, payload) {
    state.groups = payload
  },
  addGroup(state, payload) {
    state.groups.push(payload)
  },
  updateGroup(state, {id, name}) {
    let group = state.groups.find(group => group.id === id)
    if (group) {
      group.name = name
    }
  },
  deleteGroup(state, payload) {
    const index = state.groups.findIndex(group => group.id === payload)
    if (index > -1) {
      state.groups.splice(index, 1)
    }
  },
}

const actions = {
  loadGroups({ commit, state }) {
    if (state.groups.length) {
      return Promise.resolve(state.groups)
    }

    return groupService.getList()
      .then(groups => {
        commit('setGroups', groups)
        return groups
      })
  },
  addGroup({ commit }, name) {
    return groupService.create(name)
      .then(group => {
        commit('addGroup', group)
        return group
      })
  },
  updateGroup({ commit }, group) {
    return groupService.update(group)
      .then(() => {
        commit('updateGroup', group)
        return true
      })
  },
  deleteGroup({ commit }, id) {
    return groupService.delete(id)
      .then(() => {
        commit('deleteGroup', id)
        return true
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/-service-app/store/modules/groupsStore.js